<template>
    <b-overlay :show="loading" rounded="sm">
      
    <b-card class="inner-block role-listing">

        <b-card-header>
            <b-row class="mt-2">
                <b-col cols="12" class="d-flex gap-1 gap-md-2 ps-3 mt-1 mt-md-0 align-self-baseline align-self-md-center master-item-button">
                    <import-form
                    :subject="$translate('roles')"
                    v-model="importModal"
                    @cancel="hideModal()"
                    :fields="inventoryFields"
                    :upload-record="uploadInventoryRecord"
                    :isrole="isrolevalue"
                    settings-key-name="RolesUploadKey"
                  ></import-form>
                    <b-input type="text" id="search-filter" :placeholder="$translate('search_filter')" v-model="query"></b-input>
                    <!-- <b-button id="add-role" block variant="primary" v-if="hasPermissionCreate" @click="$emit('add-role')"><img
                            v-b-tooltip.hover :title="$addLabel()" src="@/assets/images/icon/blue-add.svg" /></b-button> -->
                            <b-button
              id="add-checkoff-btn"
              variant="blue-icon"
              v-b-tooltip.hover
              :title="$addLabel()"
              v-if="hasPermissionCreate"
              @click="$emit('add-role')"
              >
              <img src="@/assets/images/icon/gradient-add.svg" />
              </b-button>
                            <b-button
                            id="import-role-btn"
                            variant="blue-icon"
                            v-b-tooltip.hover
                            :title="$translate('import')"
                            @click="openModal()"
                            v-if="hasPermissionCreate"
                          >
                            <img src="@/assets/images/icon/import.svg" />
                          </b-button>
                          <b-button
                          id="export-role-btn"
                          variant="blue-icon"
                          v-b-tooltip.hover
                          :title="$translate('export')"
                          @click="export_roles()"
                          v-if="hasPermissionCreate"
                        >
                          <img src="@/assets/images/icon/export.svg" />
                        </b-button>
                            
                </b-col>
                
                
            </b-row>
        </b-card-header>
        <b-card-body class="button-off">
            <b-col class="page-block">
                <strong>
                    {{ $translate('page') }}: {{ pagination.page }} {{ $translate('of') }} {{ pageCount }} Total:
                    {{ pagination.total }}
                </strong>
            </b-col>
            <b-col class="overflow-auto w-100 mt-4">
                <b-table id="roleTable" responsive :items="roles" :fields="fields">
                    <template #cell(id)="row">
                        <b-button-group size="sm">
                            <b-button id="view-role" v-if="hasPermissionView" @click="view(row.item.id)" class="mr-2"
                                variant="pink-button">
                                <img src="@/assets/images/icon/view.svg" />
                            </b-button>
                        </b-button-group>
                    </template>
                </b-table>
            </b-col>
            <b-row>
                <b-col>
                    <b-pagination class="justify-content-center mt-4" v-model="pagination.page"
                        :total-rows="pagination.total" :per-page="pagination.pageSize" aria-controls="customerTable"
                        :prev-text="$translate('previous')" :next-text="$translate('next')" pills
                        align="right"></b-pagination>
                </b-col>
            </b-row>
        </b-card-body>
    </b-card>
    </b-overlay>
</template>
<script>
import _ from 'lodash'
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'
import importMixins from "@/mixins/importMixins";
import ImportForm from "@/components/ImportForm.vue";
const inventoryFields = [
  { name: "name", label: "name", required: true, type: "text" },
 
  {
    name: "web_access",
    label: "web_access",
    required: false,
    type: "text",
  },
  {
    name: "mobile_access",
    label: "mobile_access",
    required: false,
    type: "text",
  },
  {
    name: "feature",
    label: "feature",
    required: false,
    type: "text",
  },
  {
    name: "create",
    label: "create",
    required: false,
    type: "text",
  },
  {
    name: "create_value_type_format",
    label: "create_value_type_format",
    required: false,
    type: "text",
    options: [
      { 'value': 0, 'text': 'No'},
      { 'value': 1, 'text': 'Yes'},
    ]
  },
  {
    name: "view",
    label: "view",
    required: false,
    type: "text",
  },
  {
    name: "view_value_type_format",
    label: "view_value_type_format",
    required: false,
    type: "text",
    options: [
      { 'value': 0, 'text': 'No'},
      { 'value': 1, 'text': 'Yes'},
    ]
  },
  {
    name: "update",
    label: "update",
    required: false,
    type: "text",
  },
  {
    name: "update_value_type_format",
    label: "update_value_type_format",
    required: false,
    type: "text",
    options: [
      { 'value': 0, 'text': 'No'},
      { 'value': 1, 'text': 'Yes'},
    ]
  },
  {
    name: "delete_permission",
    label: "delete_permission",
    required: false,
    type: "text",
  },
  {
    name: "delete_permission_value_type_format",
    label: "delete_permission_value_type_format",
    required: false,
    type: "text",
    options: [
      { 'value': 0, 'text': 'No'},
      { 'value': 1, 'text': 'Yes'},
    ]
  },

];
//import autoTable from 'jspdf-autotable'
export default {
    name: 'roles-table',
    mixins: [popupMixins, permissionsMixins,importMixins],
    components: {
        ImportForm
    },
    data() {
        return {
            query: '',
            page: 1,
            //template: false,
            loading: false,
            role_data : '',
            inventoryFields,
            importModal: false,
            isrolevalue : 'yes',
        }
    },
    async mounted() {
        if (this.$route.query.query) this.query = this.$route.query.query
        await this.doSearch()
    },

    methods: {
        changePage(page) {
            this.$router.push({ query: { page } })
            this.doSearch()
        },
        async doSearch() {
          
            try {
                this.loading = true
                const {
                    pagination: { page = 1 },
                    query,
                } = this
                this.$store.dispatch("roles/set_role_filter",query);
                await this.$store.dispatch('roles/fetch', {
                    query,
                    page,
                })

            } catch (error) {
                console.error('loading error', error)
            } finally {
                this.loading = false
            }
        },
        view(index) {
            const path = `${this.$route.path}/${index}`
            this.$router.push({ path })
        },
        activityRoleView(index) {
            const path = `activity-type-roles/${index}`
            this.$router.push({ path })
        },
        truncate(text, length) {
            return _.truncate(text, { length: length })
        },
        async openModal() {
            this.importModal = true; 
        },
        handleFileUpload(event) {
         this.role_data = event.target.files[0];
       },
       async export_roles(){
            const {
                    pagination: { page = 1 },
                    query,
                } = this
            this.tableLoading = true
            await this.$store.dispatch('roles/ExportExcel',{query : query })
            this.tableLoading = false
        },
        async submitForm() {
        const formData = new FormData();
        formData.append('translations', this.translations);

            try {
                this.tableLoading = true
                await this.$store.dispatch('languages/excelImport', formData);
                this.genericToast(this.componentName, this.$translate('updated'), 'success', `${this.componentName} ${this.$translate('update_alert')}`);
                this.tableLoading = false
            } catch (error) {
                this.doToast(this.$translate('error'), error.message, 'danger');
                
            }
        },
        async exportSampleFile() {

          
        try {
            this.tableLoading = true
            await this.$store.dispatch('roles/sampleExcel',{labels : this.permissionSections});
            this.tableLoading = false
        } catch (error) {
            this.doToast(this.$translate('error'), error.message, 'danger');
        } finally {
            this.tableLoading = false
        }
        },


        async uploadInventoryRecord(
      dataRecord,
      statusRecord,
      { check, message, field },
      statuses,
      setLoading
    ) {
      try {
        let {
          name,
          mobile_access,
          web_access,
          feature, 
          create,
          view,
          update,
          delete_permission,
        
         
        } = dataRecord;
        
        const param = {
          name,
          mobile_access,
          web_access,
          feature, 
          create,
          view,
          update,
          delete_permission,
        };
       

        const res = await this.$store.dispatch("roles/upload", param);
        this.tableLoading = true;
        await this.doSearch();
        this.tableLoading = false;
        // console.log("response:", res);
        // set status to complete if the upload was successful
        statusRecord.status = statuses.COMPLETE;
      } catch (err) {
        console.error("err", err);
        statusRecord.error_list =
          typeof err.message == "string"
            ? [["error", [err.message]]]
            : Object.entries(err.message);
        statusRecord.status = statuses.ERROR;
      } finally {
        // setLoading(false);
      }
    },
    },

    watch: {
        'pagination.page': function (newPage) {
            if(this.page != newPage){
                this.changePage(newPage)
            }
            this.page = newPage
        },
        query: _.debounce(function (query) {
            this.$router.push({ query: { query } })
            this.doSearch()
        }, 200),
    },

    computed: {
        fields() {
            return [{ key: 'id', label: this.$translate('actions') }, { key: 'name', label: this.$nameLabel() }]
        },
        roles() {
            return this.$store.state.roles.items
        },
        pageCount() {
            return Math.ceil(this.pagination.total / this.pagination.pageSize)
        },
        pagination() {
            return this.$store.state.roles.pagination || []
        },
        user() {
            return this.$store.state.user
        },
       
    },
}
</script>
<style></style>
